export enum ProductType {
  Standard = 'Standard',
  Datasheet = 'Datasheet',
  StatisticsReport = 'StatisticsReport',
  SelfPacedCourse = 'SelfPaced',
  InstructorLedCourse = 'InstructorLed',
  TrainingCourses = 'TrainingCourses',
}

export const MODALITY_TITLES: Record<string, string> = {
  [ProductType.Standard]: 'Standard',
  [ProductType.Datasheet]: 'Datasheet',
  [ProductType.StatisticsReport]: 'Statistics Report',
  [ProductType.SelfPacedCourse]: 'Self Paced',
  [ProductType.InstructorLedCourse]: 'Instructor Led',
};
